@if (initialized) {
    <div class="cn-model-comparison-result">

        @if (!hasResult()) {
            <div class="text-center text-600 p-5">
                Kein Vergleichsergebnis vorhanden.
            </div>
        } @else {

            <!-- ===================== CHART ===================== -->
            <div class="surface-0 border-1 surface-border border-round p-3 mb-3">
                <div class="text-lg font-medium mb-2">Jahresreihen (nominal) — aktiv vs. Szenarien</div>
                <div class="cn-chart-host">
                    @if (chartData) {
                        <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
                    }
                </div>
            </div>

            <!-- ===================== PER-YEAR TABLE ===================== -->
            <div class="surface-0 border-1 surface-border border-round p-3 mb-3">
                <div class="text-lg font-medium mb-2">Vergleich je Jahr</div>
                <p-table [value]="yearGroups" styleClass="p-datatable-sm" [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Jahr</th>
                            <th>Modell</th>
                            <th class="text-right">Nominal</th>
                            <th class="text-right">NPV / Barwert</th>
                            <th class="text-right">Δ nominal</th>
                            <th class="text-right">Δ %</th>
                            <th class="text-right">Δ NPV</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-group>
                        <!-- Active model row -->
                        @if (activeRow(group); as active) {
                            <tr class="cn-active-row">
                                <td class="font-semibold">{{ group.year }}</td>
                                <td>
                                    <span class="font-medium">{{ getModelLabel(active.modelId) }}</span>
                                    <p-tag value="aktiv" severity="success" styleClass="ml-2"></p-tag>
                                </td>
                                <td class="text-right">{{ active.nominalSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                <td class="text-right">{{ active.npvSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                <td class="text-right text-500">–</td>
                                <td class="text-right text-500">–</td>
                                <td class="text-right text-500">–</td>
                            </tr>
                        }
                        <!-- Scenario rows -->
                        @for (scenario of scenarioRows(group); track scenario.modelId) {
                            <tr>
                                <td></td>
                                <td>{{ getModelLabel(scenario.modelId) }}</td>
                                <td class="text-right">{{ scenario.nominalSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                <td class="text-right">{{ scenario.npvSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                <td class="text-right"
                                    [class.text-green-600]="scenario.deltaNominal > 0"
                                    [class.text-red-600]="scenario.deltaNominal < 0">
                                    {{ scenario.deltaNominal | currency:'EUR':'symbol':'1.0-0':'de' }}
                                </td>
                                <td class="text-right"
                                    [class.text-green-600]="scenario.deltaPercent > 0"
                                    [class.text-red-600]="scenario.deltaPercent < 0">
                                    {{ scenario.deltaPercent | number:'1.1-1':'de' }} %
                                </td>
                                <td class="text-right"
                                    [class.text-green-600]="scenario.deltaNpv > 0"
                                    [class.text-red-600]="scenario.deltaNpv < 0">
                                    {{ scenario.deltaNpv | currency:'EUR':'symbol':'1.0-0':'de' }}
                                </td>
                            </tr>
                        }
                    </ng-template>
                </p-table>
            </div>

            <!-- ===================== BREAKDOWN TABS ===================== -->
            <div class="surface-0 border-1 surface-border border-round p-3">
                <p-tabs [value]="activeTab">
                    <p-tablist>
                        <p-tab [value]="0">Je Produkt</p-tab>
                        <p-tab [value]="1">Je Sparte</p-tab>
                    </p-tablist>
                    <p-tabpanels>
                        <p-tabpanel [value]="0">
                            @if (productBreakdown.length) {
                                <p-table [value]="productBreakdown" styleClass="p-datatable-sm">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Produkt</th>
                                            <th class="text-right">Nominal</th>
                                            <th class="text-right">NPV / Barwert</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-row>
                                        <tr>
                                            <td>{{ row.dimensionLabel || row.dimensionKey }}</td>
                                            <td class="text-right">{{ row.nominalSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                            <td class="text-right">{{ row.npvSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            } @else {
                                <div class="text-600 p-3 text-center">Keine Produkt-Aufschlüsselung vorhanden.</div>
                            }
                        </p-tabpanel>
                        <p-tabpanel [value]="1">
                            @if (sparteBreakdown.length) {
                                <p-table [value]="sparteBreakdown" styleClass="p-datatable-sm">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Sparte</th>
                                            <th class="text-right">Nominal</th>
                                            <th class="text-right">NPV / Barwert</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-row>
                                        <tr>
                                            <td>{{ row.dimensionLabel || row.dimensionKey }}</td>
                                            <td class="text-right">{{ row.nominalSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                            <td class="text-right">{{ row.npvSum | currency:'EUR':'symbol':'1.0-0':'de' }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            } @else {
                                <div class="text-600 p-3 text-center">Keine Sparten-Aufschlüsselung vorhanden.</div>
                            }
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </div>

        }
    </div>
}
